import { render } from "./UserStatus.vue?vue&type=template&id=6a5d3b64&scoped=true"
import script from "./UserStatus.vue?vue&type=script&lang=js"
export * from "./UserStatus.vue?vue&type=script&lang=js"

import "./UserStatus.vue?vue&type=style&index=0&id=6a5d3b64&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6a5d3b64"

export default script